import { render, staticRenderFns } from "./QueueEventItem.vue?vue&type=template&id=9643ae02&scoped=true&"
import script from "./QueueEventItem.vue?vue&type=script&lang=js&"
export * from "./QueueEventItem.vue?vue&type=script&lang=js&"
import style0 from "./QueueEventItem.vue?vue&type=style&index=0&id=9643ae02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9643ae02",
  null
  
)

export default component.exports